import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, DateTime, EventTriggers, RequiredValidator } from '../../Components/Form';
import { useRound } from '../../Data/Rounds';
import { eventTriggers } from '../../Data/Misc';

const MarkRoundDone = ({round, isOpen, onClose, onSave}) => {
    return <Modal title="Mark round as done" isOpen={isOpen} setIsOpen={onClose} dismissible>
        {round && <Inner round={round} onSave={onSave} />}
    </Modal>
}

const Inner = ({round, onSave}) => {
    const {markAsDone} = useRound(round.id);

    return <Form data={{jobIds: round.jobIds}}
            onSubmit={data => markAsDone(data)}
            afterSubmit={onSave}
            closeModalOnSubmit
        >
        <DateTime name="doneAt" label="Date" validators={[RequiredValidator]} showDatePrompts defaultNow />
        <EventTriggers triggers={[
            eventTriggers.SEND_NOTIFICATIONS, eventTriggers.INVOICE, eventTriggers.CHARGE, eventTriggers.LOYALTY_CARDS
        ]} />
        <Actions submit={{label: 'Mark as done'}} cancel />
    </Form>
}

export default MarkRoundDone;
